export default __webpack_public_path__ + "static/media/icons.ef540dd0.png";